import { useTu } from "@src/appV2/i18n/useTu";
import { MenuItem, TextField } from "@mui/material";
import { Controller } from "react-hook-form";
import { FieldShell } from "./FieldShell";

import {
  buildFieldIds,
  getNestedError,
  hasNonEmptyDescription,
  type SchemaFieldProps,
} from "./utils";

export function EnumField({
  fieldKey,
  property,
  fieldPath,
  isRequired,
  control,
  errors,
}: SchemaFieldProps) {
  const { tu } = useTu("evidence");

  const errorMessage = getNestedError(errors, fieldPath);
  const { describedBy } = buildFieldIds(fieldPath, hasNonEmptyDescription(property.description));
  const options = property.enum ?? [];

  return (
    <FieldShell
      fieldKey={fieldKey}
      descriptionId={describedBy}
      isRequired={isRequired}
      description={property.description}
    >
      <Controller
        name={fieldPath}
        control={control}
        rules={isRequired ? { required: "This field is required" } : undefined}
        defaultValue=""
        render={({ field }) => (
          <TextField
            select
            name={field.name}
            inputRef={field.ref}
            label={fieldKey}
            required={isRequired}
            size="small"
            value={field.value ?? ""}
            error={Boolean(errorMessage)}
            helperText={errorMessage}
            inputProps={{ "aria-describedby": describedBy }}
            sx={{ width: 300 }}
            onBlur={field.onBlur}
            onChange={field.onChange}
          >
            <MenuItem disabled value="">
              {tu("Select {{fieldKey}}", { values: { fieldKey } })}
            </MenuItem>
            {options.map((option) => (
              <MenuItem key={option} value={option}>
                {option}
              </MenuItem>
            ))}
          </TextField>
        )}
      />
    </FieldShell>
  );
}
